import { clearAnalyticsIdentity, identifyUser, trackEvent } from "./analytics"

const posthog = {
    capture: trackEvent,
    identify: identifyUser,
    reset: clearAnalyticsIdentity,
}

export default posthog
